// Angular
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
// Object-Path
// Layout
import { LayoutConfigService, SplashScreenService } from '../../../../core/_base/layout';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-splash-screen',
  templateUrl: './splash-screen.component.html',
  styleUrls: ['./splash-screen.component.scss']
})
export class SplashScreenComponent implements OnInit {
  // Public proprties
  loaderLogo: string;

  loaderType: string;

  loaderMessage: string;

  @ViewChild('splashScreen', {static: true}) splashScreen: ElementRef;


  constructor(
    private cdr: ChangeDetectorRef,
    private el: ElementRef,
    private layoutConfigService: LayoutConfigService,
    private splashScreenService: SplashScreenService
  ) {
  }

  /**
   * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
   */

  /**
   * On init
   */
  ngOnInit() {
    // init splash screen, see loader option in layout.config.ts
    // const loaderConfig = this.layoutConfigService.getConfig('loader');
    this.loaderLogo = 'https://qb-whitelabel.s3.af-south-1.amazonaws.com/' + window.location.hostname + '/loading.png';

    this.splashScreenService.init(this.splashScreen);
  }

  setDefaultPic() {
    this.loaderLogo = '';
    this.cdr.detectChanges();
  }
}
